import { useRoundSettingForm } from '@/features/foreign_currency_settings/components/RoundSetting/hooks/useRoundSettingForm';
import { RoundSettingInfo } from '@/features/foreign_currency_settings/components/RoundSetting/RoundSettingInfo';
import { RoundSettingModal } from '@/features/foreign_currency_settings/components/RoundSetting/RoundSettingModal';
import { useIsRoundSettingEdit } from '@/features/foreign_currency_settings/context/RoundSettingEdit';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useCallback, useState } from 'react';
import styles from './RoundSetting.module.scss';

const cx = classnames.bind(styles);

export const RoundSetting: FC = memo(() => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const formMethods = useRoundSettingForm();
  const onSave = useCallback(() => {
    setModalOpen(true);
  }, []);

  const { isEdit, onView, onEdit } = useIsRoundSettingEdit();

  const onClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const onCancel = useCallback(() => {
    onView();
    formMethods.reset();
  }, [onView, formMethods]);

  return (
    <>
      <div className={cx(styles['container'])}>
        <div className={cx(styles['title-container'])}>
          <div className={cx(styles['title'])}>
            {t('foreign_currency.round_setting.title')}
          </div>
          {isEdit ? (
            <ButtonGroup direction='horizontal'>
              <ButtonV2 color='primary' isSecondary onClick={onCancel}>
                {t('cancel')}
              </ButtonV2>
              <ButtonV2 color='primary' onClick={onSave}>
                {t('save')}
              </ButtonV2>
            </ButtonGroup>
          ) : (
            <ButtonV2 color='primary' isSecondary onClick={onEdit}>
              {t('edit')}
            </ButtonV2>
          )}
        </div>
        <RoundSettingInfo onModalClose={onClose} formMethods={formMethods} />
      </div>
      <RoundSettingModal
        open={isModalOpen}
        onClose={onClose}
        formMethods={formMethods}
      />
    </>
  );
});
RoundSetting.displayName = 'RoundSetting';
